import React from 'react';

import FormCard from './FormCard';
import FormAction from './FormAction';

interface FormProProps {
    children: React.ReactNode;
    className?: string;
}

const FormPro = (props: FormProProps) => {
    const {className = ''} = props;
    return (
        <div className={`acud-pro-form-pro-container ${className}`}>
            {props.children}
        </div>
    );
};

FormPro.FormCard = FormCard;
FormPro.FormAction = FormAction;

export default FormPro;